import React, { Component } from "react";
import { connect } from "react-redux";
import CustomBoardGiro from "../../../components/CustomBoardGiro";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../components/CustomText";
import Color from "../../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomButton from "../../../components/CustomButton";
import * as selector from "../../../../common/selectors";
import * as onlineRenewalSelector from "../../../../common/selectors/onlineRenewal";
import * as onlineRenewalAction from "../../../../common/actions/onlineRenewal";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import LoadingOverlay from "../../../components/LoadingOverlay";
import CustomPaper from "../../../components/CustomPaper";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Image from "../../../../assets";
import CustomBoardSelectEnrolment from "../../../components/CustomBoardSelectEnrolment";
import _ from "lodash";
import CustomEnrolGiroNowV2 from "../../../components/CustomEnrolGiroNowV2";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import AddIcon from "@material-ui/icons/Add";
import Files from "react-butterfiles";


const screenW = window.screen.width + "px";
const screenH = "450" + "px";

class DDAMissMatchYes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      localPolicyNo: "",
      localStatus: "",
      localNric: "",
      localPremium: "",
      localIsRecurring: false,
      localProduct: "",
      localCoveragePeriod: "",
      localStatusLabel: "",
      localMsg: "",
      checkedA: false,
      localShowRecurringCheckBox: false,
      loadingToReddot: false,
      localErrorCode: "",
      localErrorMsg: "",
      payorName: "",
      payorNRIC: "",
      payorRelationship: "",
      selectedFiles:[],
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    var status = this.getUrlVars()["status"];
    var policy = this.getUrlVars()["Policy"];
    this.setState({
      localStatus: status === "success" ? true : false,
      localPolicyNo: policy,
    });
    var errorCode = this.getUrlVars()["ErrorCode"];
    var errorMsg = this.getUrlVars()["ErrorMessage"];
    //console.log("typeof", errorCode.length);
    this.setState({ localErrorCode: errorCode, localErrorMsg: errorMsg });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidUpdate = () => {};

  getUrlVars() {
    var url = window.location.href,
      vars = {};
    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      key = decodeURIComponent(key);
      value = decodeURIComponent(value);
      vars[key] = value;
    });
    return vars;
  }

  onClickLetGo = () => {
    //this.onClickPayRenewal();
    this.props.history.push("/EnrolGiro");
  };

  onClickEnrolNow = () => {
    this.props.history.push("/EnrolmentStatus");
  };

  onClickHere = () => {};

  handleChangeCheckedA = (event) => {
    this.setState({ checkedA: event.target.checked });
  };

  retryEnrol = () => {
    this.props.history.push("/EnrolGiro");
  };

  handleAddImage = (files) => {
    files.map((item, index) => {
        this.setState({selectedFiles:[
          ...this.state.selectedFiles,
          {
            FileName: item.name,
            FileType: item.type,
            FileData: item.src.base64,
          },
        ]});
      });
  };

   handleDeleteImage = (index) => {
    _.remove(this.state.selectedFiles, (item, key) => {
        return key === index;
      });
      this.setState({selectedFiles: [...this.state.selectedFiles]});
  };

   handleSubmitButton = (selectedFiles) => {
    if (selectedFiles.length <= 0) {
        //setCustomToastStatus(true);
        //setToastMessage("Please upload your NRIC");
        alert("please upload your nric")
        return;
      }
     // setCustomToastStatus(false);
     // handleSubmitModal && handleSubmitModal(selectedFiles);
  };


  renderChildrenV2 = () => {
    const { classes } = this.props;
    const {
      policyNo,
      isOnClickNext,
      errorMsg,
      error,
      payorName,
      payorNRIC,
      payorRelationship,
      selectedFiles
    } = this.state;
    return (
      <CustomPaper
        container
        direction={"column"}
        spacing={2}
        design={classes.paper}
      >
        <Grid
          item
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: "8%",
            paddingRight: "8%",
            marginBottom: "3%",
          }}
        >
          {" "}
         
            <CustomText design={classes.titleTextStyle}>
              <b>NOTE: </b> Please attach a copy of NRIC in PDF/ JPG format
              only, with total file size not more than 10MB
            </CustomText>
         
        </Grid>

       
      
        <Grid container style={{ marginBottom: 10 }}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
          
            <div className={classes.titleTextContainer}>
              <CustomText design={classes.contentTextStyle}>
                Please attach front & back
              </CustomText>
            </div>
            <Files
              multiple={true}
              maxSize="10mb"
              multipleMaxSize="10mb"
              multipleMaxCount={3}
              accept={["application/pdf", "image/jpg", "image/jpeg"]}
              onSuccess={this.handleAddImage}
              onError={(errors) => {
                alert(errors[0].type);
              }}
              convertToBase64={true}
            >
              {({ browseFiles }) => (
                <>
                  <Grid container spacing={0} direction={"row"}>
                    {Array.isArray(selectedFiles) && selectedFiles.map((item, index) => (
                      <Grid
                        item
                        style={{
                          marginTop: 10,
                          marginRight: 20,
                        }}
                        key={index}
                      >
                        <Grid container direction={"column"}>
                          {item.FileType === "application/pdf" ? (
                            <PictureAsPdfIcon
                              className={classes.selectedImageStyle}
                            />
                          ) : (
                            <img
                              src={`${item.FileData}`}
                              className={classes.selectedImageStyle}
                            />
                          )}
                          <div onClick={() => this.handleDeleteImage(index)}>
                            <CustomText design={classes.cancelIconStyle}>
                              Remove
                            </CustomText>
                          </div>
                        </Grid>
                      </Grid>
                    ))}
                    <Grid
                      item
                    //   style={{ padding: matchesXS ? 7 : 25, marginTop: 10 }}
                      className={classes.borderStyle}
                      onClick={browseFiles}
                    >
                      <div>
                        <AddIcon className={classes.addIconStyle} />
                      </div>
                    </Grid>
                  </Grid>
                </>
              )}
            </Files>
        
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>
        <Grid container style={{paddingLeft:"8%",paddingRight:"8%",marginTop:20}} >
          <Grid item xs={5} >
          <CustomButton
            onClick={this.retryEnrol}
            style={{ textTransform: "none" }}
          >
            Submit
          </CustomButton>
          </Grid>
          <Grid item xs={2} >
        
          </Grid>
          <Grid item xs={5}>
          <CustomButton
            onClick={this.retryEnrol}
            style={{ textTransform: "none" }}
            design={classes.cancelButtonTextStyle}
          >
            Cancel
          </CustomButton>
          </Grid>
        </Grid>
      </CustomPaper>
    );
  };

  render() {
    const { classes } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        {/* <CustomEnrolGiroNowV2
            children={this.renderChildren()}
            height={window.innerWidth < 600 ? height + 200 : height}
            width={width}
          /> */}
        {window.innerWidth > 600 ? (
          <AppBar
            position="sticky"
            className={classes.appBar}
            style={{ background: "#333333" }}
          >
            <Toolbar
              className={classes.toolbarStyle}
              style={{
                justifyContent: "space-between",
                //alignItems: "center",
                display: "flex-start",
                flexDirection: "row",
                marginLeft: "5em",
              }}
            >
              <img
                src={Image.nonDirectClientEtiqaLogo}
                style={{ width: 112, height: 60 }}
              />
            </Toolbar>
          </AppBar>
        ) : (
          false
        )}
        {window.innerWidth > 600 ? this.renderChildrenV2() : false}
        {window.innerWidth < 601 ? (
          <CustomEnrolGiroNowV2
            children={this.renderChildrenV2()}
            height={height}
            width={width}
          />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#f4f4f4",
    maxHeight: "100vh",
    minHeight: "100vh",
    backgroundImage:
      window.innerWidth < 601 ? false : `url(${Image.enrolGiroBg})`,
    backgroundSize: window.innerWidth < 601 ? false : `${screenW} ${screenH}`,
    backgroundPosition: window.innerWidth < 601 ? false : "bottom center",
    backgroundRepeat: window.innerWidth < 601 ? false : "no-repeat",
  },
  imageStyle: {
    width: 57,
    height: 57,
    alignItems: "center",
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  letGoButtonStyle: {
    //width: 120,
    marginTop: 20,
    //marginBottom:"1em"
  },
  buttonTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  // renewNowTextStyle: {
  //   ...getFontWeight("800"),
  //   fontSize: 28,
  //   textAlign: "center",
  //   color: "#2c3034",
  //   marginBottom: 10,
  // },
  errorTextStyle: {
    color: "red",
  },

  checked: {},
  optTextStyle: {
    fontSize: 13,
    opacity: 0.7,
  },
  submitPaper: {
    //margin: 20,
    border: "1px solid #C5C5C5",
    borderRadius: " 0",
    //minWidth:500
  },
  failurePaymentPaper: {
    margin: 20,
    [theme.breakpoints.between("sm", "md")]: {
      width: 600,
    },
    [theme.breakpoints.up("lg")]: {
      width: 800,
    },
  },
  appBar: {
    background:
      "transparent linear-gradient(143deg, #004880 0%, #0066A7 31%,#007F9C 59%,#008992 80%,#00FFAF 100%) 0% 0% no-repeat padding-box",
  },
  titleStyle: {
    fontSize: "22px",
    ...getFontWeight("800"),
    marginBottom: 20,
  },
  backButton: {
    //width: 120,
    marginTop: 20,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  paper: {
    // overflow: "auto",
    //backgroundColor: "#f4f4f4",
    //width:"828px",
    marginTop: window.innerWidth < 601 ? false : "6%",
    marginLeft: window.innerWidth < 601 ? false : "25%",
    marginRight: window.innerWidth < 601 ? false : "25%",
  },
  renewNowTextStyle: {
    fontWeight: "bold",
    fontFamily:"Muli",
    fontSize: 22,
    textAlign: "center",
    marginBottom: 10,
    marginTop: 10,
  },
  noteTextStyle: {
    fontFamily:"Muli",
    fontSize: "16px",
    fontWeight: "400",
    color: "#424143",
  },
  cancelButtonTextStyle: {
    backgroundColor: "#fff",
    color: "#424143",
    borderRadius: 8,
    "&:focus": {
      color: "white",
      //backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
    "&:hover": {
      color: "white",
      // backgroundColor: Color.blackButtonColor
    },
  },
  labelTextInputTextStyle: {
    ...getFontWeight("400"),
   fontSize:"16px",
    color: "#424143",
    fontFamily:"Muli"
  },
  textInputContainer: {
    height: 45,
    marginTop: 7,
  },
  selectedImageStyle: {
    [theme.breakpoints.down("xs")]: {
      width: 40,
      height: 40,
    },
    [theme.breakpoints.up("sm")]: {
      width: 80,
      height: 80,
    },
    borderRadius: 5,
    boxShadow: "0 0 10px 0 rgba(18, 38, 63, 0.08)",
  },
  cancelIconStyle: {
    [theme.breakpoints.down("xs")]: {
      fontSize: 10,
    },
    color: Color.debitTextColor,
    marginTop: 5,
    textAlign: "center",
    ...getFontSize("xxsmall"),
    textDecoration: "underline",
    cursor: "pointer",
  },
  borderStyle: {
    display: "inline-block",
    border: "dashed 1px #ced4da",
    borderImageSlice: 2,
    borderImageRepeat: "round",
    [theme.breakpoints.down("xs")]: {
      width: 40,
      height: 40,
    },
    [theme.breakpoints.up("sm")]: {
      width: 80,
      height: 80,
    },
    borderRadius: 5,
    "&:hover": {
      cursor: "pointer",
    },
  },
  addIconStyle: {
    width: 24,
    height: 24,
  },
});

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(DDAMissMatchYes)));
